import { getAllHazards } from '@/lib/config/hazardConfig';

export interface Hazard {
  name: string;
  icon: string;
}

/**
 * @deprecated Use getAllHazards() from @/lib/config/hazardConfig instead
 * This is kept for backwards compatibility
 */
export const hazards: Hazard[] = getAllHazards().map(def => ({
  name: def.name,
  icon: `/hazards/${def.name}.png`,
}));
